module.exports = require('react/lib/ReactComponentWithPureRenderMixin');


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-addons-pure-render-mixin/index.js
 ** module id = 486
 ** module chunks = 1
 **/